// 希伯来
module.exports = {
  common: {
    edit: "לַעֲרוֹך",
    apply: "להגיש מועמדות",
    activate: "הַפעָלָה",
    delete: "לִמְחוֹק",
    cancel: "לְבַטֵל",
    success: "הַצלָחָה",
    fail: "לְהִכָּשֵׁל",
    save: "להציל",
    ensure: "בטוח",
    submit: "שלח",
    remark: "הֶעָרָה",
    detail: "חשבון",
    action: "לְהַפְעִיל",
    open: "לִפְתוֹחַ",
    close: "סגירת מעגל",
    back: "לַחֲזוֹר",
    export: "יְצוּא",
    modify: "לְשַׁנוֹת",
    layout: "התנתק",
    noListData: "לרשימה אין נתונים",
    more: "פרטים",
    add: "לְהוֹסִיף",
    delSuccess: "נמחק בהצלחה!",
    addFailure: "הוספה נכשלה!",
    logOut: "להתנתק",
    delAllInfo: "האם אתה רוצה להמשיך בפעולת המחיקה?",
    saveTip: "לא שמרת את תוכן העמוד, האם אתה רוצה להמשיך לעזוב?",
    tip: "רֶמֶז",
    yes: "כן",
    no: "לא",
    delTip: "סמן כדי להפעיל",
    batchDelete: "מחיקת אצווה",
    search: "לברר",
    permission: "אין רשות עדיין, בבקשה חזור",
    reset: "אִתחוּל",
  },
  breadcrumbItem: {
    home: "תצורת רשימת שמות",
    data: "אריזה של תצורה כללית של המכשיר",
    alarm: "תצורת אזור",
    house: "תצורת פריסת הבית",
    name: "תצורת רשימת שמות",
  },
  errorRes: {
    res82: "המערכת תפוסה, אנא נסה שוב מאוחר יותר",
  },
  openConfig: {
    title: "תצורה כללית של המכשיר",
    version: "גרסת פרוטוקול",
    versionTip: "אנא בחר גרסת פרוטוקול",
    checkVersion: "גרסת הפרוטוקול לא יכולה להיות ריקה, אנא בחר שוב",
    signType: "סוג אלגוריתם חתימה",
    checkSignType: "סוג אלגוריתם החתימה לא יכול להיות ריק, אנא בחר שוב",
    fileLabel: "בחר מסמך",
    addFile: "הוסף קבצים",
    fileName: "שם קובץ",
    zipType: "שיטת דחיסה",
    noZip: "אין דחיסה",
    noFile: "עדיין לא נוספו קבצים",
    checkFile: "קובץ התצורה ריק, נא הוסף קובץ",
    name: "שֵׁם",
    nameTip: "אורך הקלט הוא 1-10 ספרות",
    checkName: "השם לא יכול להיות ריק, נא להזין מחדש",
    checkName1: "קלט שם שגוי, נא להזין מחדש",
    room: "זיהוי מכשיר",
    roomTip: 'אורך הקלט הוא 1-24 סיביות, והרמה נבדלת על ידי "-"',
    checkRoom: "מספר המכשיר לא יכול להיות ריק, נא להזין מחדש",
    checkRoom1: "הקלטת מספר המכשיר שגויה, נא להזין מחדש",
    pic: "תְמוּנָה",
    add: "להוסיף ל",
    reset: "אִתחוּל",
    picTip: "גודל ההעלאה המקסימלי של קובץ תמונה הוא 3 מטר",
    checkPic: "קובץ התמונה לא יכול להיות ריק, אנא בחר מחדש",
    imgRegTip: "העלה רק קבצים בפורמטים jpg, jpeg, png",
    excRegTip: "העלה רק קבצים בפורמט xls ו-xlsx",
    zipRegTip: "העלה רק קבצים בפורמט zip",
    produce: "צור קובץ תצורה",
    confType: "סוג תצורה",
    pack: "חבילה",
    batchAdd: "הוספת אצווה",
    singleAdd: "הוסף בודד",
    modelBatch: "הורד תבנית ייבוא אצווה",
    uploadInfo: "העלה מידע בסיסי לאקסל",
    uploadPic: "העלה חבילת תמונה Zip",
    addName: "הוסף פיסת נתונים בודדת",
    sameTip: "מספר סידורי:",
    sameTip1: "שכפל מספר מכשיר",
    modelError:
      "תוכן קובץ המידע הבסיסי שהועלה שגוי, אנא שנה את הקובץ בהתאם לתבנית",
    noPic:
      "יש נתונים ברשימה שלא נוספו עם תמונות, עליך להשלים את התמונות לפני יצירת קובץ התצורה",
    picBtnTip: "אנא העלה תחילה את קובץ המידע הבסיסי",
    devType: "סוג ציוד",
    devTypeTip: "אנא בחר סוג מכשיר",
    checkDevType: "סוג המכשיר לא יכול להיות ריק, אנא בחר שוב",
    indexName: "מספר סידורי",
    IS: "יחידה פנימית",
    GU: "מכונת ניהול",
    OS1: "תחנת קול",
    OS2: "מכונת קיר",
    OS3: "תחנת דלת קטנה",
    nameListTip:
      "בנתונים הבסיסיים שהועלו יש נתונים עם שדה שם לא שלם, ושאר הנתונים הנכונים יובאו",
    numListTip:
      "בנתונים הבסיסיים שהועלו, יש נתונים לא מלאים בשדה מספר המכשיר, ושאר הנתונים הנכונים יובאו",
  },
  alarm: {
    ad: "אזור AD",
    io: "אזור IO",
    alarmPlus: "הרחבת אזור",
    num: "מספר סידורי",
    open: "לִפְתוֹחַ",
    close: "סגור",
    machine: "סוג גלאי",
    sendType: "סוג טריגר",
    mode: "דֶגֶם",
    mType1: "אינפרא אדום",
    mType2: "מגנטי לדלת",
    mType3: "מגנט לחלון",
    mType4: "גַז",
    mType5: "עָשָׁן",
    mType6: "פעמון דלת",
    mType7: "לחצן ניוזלטר",
    mType8: "חיישן דלת אינפרא אדום",
    mType9: "חיישן דלת אזעקת יד",
    mType10: "רֶטֶט",
    mType11: "לחץ אוויר",
    mType12: "אַחֵר",
    send1: "דווח מיד תוך 24 שעות",
    send2: "אזעקה מושהית",
    send3: "עיכוב העברה",
    send4: "תתקשר מיד למשטרה",
    send5: "אזעקה צולבת",
    mode1: "בדרך כלל פתוח",
    mode2: "לעתים קרובות כבוי",
    presence: "בבית",
    leaving: "עוזב את הבית",
    timeSet: "הגדרת זמן הקשורה לזרוע",
    delayTime: "עיכוב יעיל להפעלת (שניות)",
    startDelay: "השהיית הפעלת אזעקה (שניות)",
    startUtil: "משך אזעקה (דקות)",
    associated: "אזור משויך",
  },
  house: {
    dev: "צִיוּד",
    scene: "סצינות",
    vine: "חיישן",
    single: "שליטה עצמאית בסצינות",
    light: "אוֹר",
    air: "מזגן",
    heat: "חימום רצפתי",
    fresh: "רוח רעננה",
    switch: "שקע מתג",
    curtain: "וִילוֹן",
    water: "מחמם מים",
    bgm: "מוזיקת רקע",
    cust: "מכשיר מותאם אישית",
    slight: "אוֹר",
    sAir: "מזגן",
    sHeat: "חימום רצפתי",
    sFresh: "רוח רעננה",
    sSwitch: "שקע מתג",
    sCurtain: "וִילוֹן",
    sWater: "מחמם מים",
    sBgm: "מוזיקת רקע",
    sCust: "מכשיר מותאם אישית",
    IndependentControl: "שליטה עצמאית בסצינות",
    scene1: "סצנה 1",
    scene2: "סצנה 2",
    scene3: "סצנה 3",
    scene4: "סצנה 4",
    scene5: "סצנה 5",
    scene6: "סצנה 6",
    scene7: "סצנה 7",
    scene8: "סצנה 8",
    temp1: "טֶמפֶּרָטוּרָה",
    temp2: "לחות",
    temp3: "מתאן",
    temp4: "גז אורגני",
    picTip: "אין תוכנית קומה",
    upload: "העלה תוכנית קומה",
    imgSize: "גודל התמונה של תוכנית קומה בודדת לא יעלה על 10M",
    imgName: "שם קובץ תכנית הקומה שהועלה אסור להופיע בסינית, אנא בחר שוב",
    imgLength:
      "המספר הכולל של העלאות ותוספות תוכנית קומה לא יעלה על 8, ו-8 התמונות הראשונות בתיקייה נבחרו אוטומטית",
    imgCheckTip: "תוכנית הקומה לא תואמת, נא להעלות מחדש",
    room1: "בית סוג 1",
    room2: "בית סוג 2",
    room3: "בית סוג 3",
    room4: "בית סוג 4",
    room5: "בית סוג 5",
    room6: "בית סוג 6",
    room7: "בית סוג 7",
    room8: "סוג בית איור 8",
    download: "יְצוּא",
    input: "ייבוא תצורה",
    title: "טבלת פרמטרים של ציוד",
    name: "שֵׁם",
    location: "מקום",
    start: "סטארט - אפ",
    see: "גלוי",
    noSee: "בלתי נראה",
    belong: "שייך ל",
    bgIcon: "אייקון אפור כחול",
    vineTip: "אנא בחר את תוכנית הרצפה לפני הגדרת מאפייני בקרת הטמפרטורה",
    sceneTip: "אנא בחר את תוכנית הקומה, ולאחר מכן הגדר את מאפייני הסצנה",
    dragTip: "אנא בחר את תוכנית הקומה לפני ביצוע פעולת הגרירה",
    editTip: "נערכה בהצלחה",
    addTip: "בעת העלאה, עליך לבחור את כל תוכניות הרצפה בבת אחת",
    editError: "נא לציין את תוכן העריכה לפני העריכה",
    delError: "נא לציין את התוכן שיימחק לפני המחיקה",
    delTip: "נמחק בהצלחה",
    imgAddTip:
      "המספר הכולל של תוכניות הקומה שהועלו והוספו הגיע ל-8, ולא ניתן להוסיף עוד",
    houseTitle: "החלפת מפה מסוג בית:",
    delHouseTip:
      "פעולה זו תמחק את תוכנית הקומה ואת תוכן התצורה. האם אתה רוצה להמשיך?",
    sendTip: "ייבא את תוכן התצורה כדי לשנות שוב, אתה יכול להעלות את קובץ ה-xml",
    checkType: "הפורמט של הקובץ שהועלה שגוי, אנא בדוק את תוכן הקובץ והעלה שוב",
    importTip: "ייבוא קובץ תצורה",
    importTip1: "יבא את תוכנית הקומה המתאימה",
    upLoadBtn: "העלה",
    picContent:
      "סדר העלאת תוכניות הקומה חייב להיות עקבי עם סדר תוכניות הקומה בקובץ התצורה",
    successFile: "קובץ התצורה הועלה בהצלחה",
    vineTipCheck: "השם לא יכול להיות ריק, אנא אשר את הקלט",
    picNumMax:
      "נא לאשר את מספר התמונות המיובאות. המספר הנוכחי של התמונות המיובאות גדול ממספר תוכניות הבית בקובץ התצורה. נא לבחור מחדש",
    picNumMin:
      "נא לאשר את מספר התמונות המיובאות. המספר הנוכחי של התמונות המיובאות קטן ממספר תוכניות הבית בקובץ התצורה. אנא בחר שוב",
    maxSizeTip:
      "המספר או המספר הכולל של תוספות מסוג זה חורגים מהמגבלה. אם אתה צריך להוסיף, אנא מיין תחילה את המכשירים או הסצנות שנוספו.",
    devNameTip: "אנא הכנס שם",
    chromeTip: "דפדפן כרום מומלץ",
    downTip: "לחץ כדי לדלג לקישור ההורדה",
    imgRegTip: "העלה רק קבצים בפורמטים jpg ו-jpeg",
    threeTitle: "מערכת שלוש קבועות",
    mainControl: "לִשְׁלוֹט",
    sedControl: "בקרת משנה",
    controlBtn: "תְצוּרָה",
    configEdit: "פרטי תצורת המערכת של Sanheng",
    moveTip: "אנא גרור את הסמל לאזור תוכנית הקומה, אנא גרור אותו שוב",
    repeatNameTip: "לא ניתן להעלות תוכניות קומה באותו שם, אנא בחר שוב",
    space: "(שמורות)",
  },
  updateConfig: {
    tip0: "בעת הגדרת אזעקת 24 שעות, הגדר את המתג למצב ON",
    tip1: "בעת הגדרת אזעקת 24 שעות, המתג צריך להיות מופעל",
    tip2: "בעת הגדרת אזעקה מיידית, המתג צריך להיות במצב מופעל",
    tip3: "כאשר אזעקת העיכוב כבויה, יש להגדיר את עיכוב המסירה לכבוי",
    tip4: "הוגדרה אזעקה צולבת, צריך פעולה משויכת",
    tip5: "אנא הפעל קודם את אזעקת ההשהיה",
    tip6: "בעת הגדרת אזעקה מיידית, הגדר את המתג למצב מופעל",
  },
  audio: {
    title: "כלי אריזת תחזוקת קול",
    lock: "קול פתיחה",
    call: "קריאת קול",
    speak: "קריאת דיבור",
    busy: "קריאה תפוסה",
    tip1: "לחץ להעלות קובץ בפורמט .wav",
    tip2: "גודל הקובץ לא ישתף פעולה עם 1MB",
    tip3: "אנא העלה קובץ בפורמט .wav",
    tip4: "אנא העלה את כל הקבצים",
    add: "יצירת קבצים",
  },
  threeProject: {
    hotWater: "מערכת מי חמים",
    cho: "פורמלדהיד",
    config: "להגדיר",
    unconfig: "ללא הגדרה",
  },
  elevator: {
    title: "יצירת תצורת בקרת מעלית",
    label: "העלאה של טבלת תצורת בקרת מעלית",
    uploadTip: "יש ללחוץ או לגרור את הקובץ לאזור זה כדי להעלות",
    upload: "העלאה",
    download: "הורדת תבנית",
    downloadTip: "יש ללחוץ כדי להוריד את תבנית טבלת תצורת בקרת המעלית",
    error1: "[קומה פיזית] שגויה. יש לבדוק את קובץ התצורה ולהעלות שוב",
    error2: "[קומה לתצוגה] שגויה. יש לבדוק את קובץ התצורה ולהעלות שוב",
    error3:
      "[כתובת שער בקרת המעלית] שגויה. יש לבדוק את קובץ התצורה ולהעלות שוב",
    error4: "[תצוגת מספר המעלית] שגויה. יש לבדוק את קובץ התצורה ולהעלות שוב",
    error5: "[כתובת IP של ההתקן] שגויה. יש לבדוק את קובץ התצורה ולהעלות שוב",
    error6:
      "[שער בקרת המעלית] חורג מהמגבלה. יש לבדוק את קובץ התצורה ולהעלות שוב",
    generate: "תבנית טבלת תצורת בקרת מעלית",
    fileLabel: "קובץ תצורת בקרת מעלית:",
    tip: "יש להכניס את קובץ התצורה אל [שדרוג משאבים] בכלי ה-PC כדי לייבא את ההגדרות אל ההתקן",
    downloadfile: "הורדה",
    fileName: "תצורת בקרת מעלית.xlsx",
    formatError: "פורמט הקובץ שהועלה שגוי, יש לבדוק את תוכן הקובץ ולהעלות שוב",
  },
};
